/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meta_List_Status_FullInputs */



/**
* | output |
* | --- |
* | "Full list" |
*
* @param {Meta_List_Status_FullInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const meta_list_status_full = /** @type {((inputs?: Meta_List_Status_FullInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meta_List_Status_FullInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Vollständige Liste")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Liste complète")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("完整卡组表")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("完整牌組清單")
	if (locale === "ko") return /** @type {LocalizedString} */ ("전체 리스트")
	return /** @type {LocalizedString} */ ("Full list")
});